module.exports = __webpack_public_path__ + "../resources/img/ic_re_info_default.53354250.svg";